import { useEffect, useState } from "react";
import SearchResultRow from "./SearchResultRow";

export interface UserSessionDto {
    id: number;
    login: string;
    role: string;
}

function AdminComponent() {
    const [result, setResult] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [message, setMessage] = useState("Chargement en cour");


    useEffect(() => {

        fetch("" + process.env.REACT_APP_API_URL + "/admin/search?param=" + searchTerm, {
            method: "GET",
            headers: {
                "Authorization": 'Bearer ' + sessionStorage.getItem("token")
            }

        })
            .then((response) => response.json())
            .then((json) => setResult(json))
            .catch(() => setMessage("ERROR"));

    }, [searchTerm]);

    function handleChange(event: any) {
        setSearchTerm(event?.target.value);
    }




    return (<>
        <input type="text" id="admin-search-bar" onChange={handleChange} />
        <section className="user-list">

            {
                result.length == 0 ? message :
                    <>
                        <table>
                            <tbody>
                                {
                                    result!.map((elem: UserSessionDto, index) => {
                                        // console.log(elem.role);

                                        return < SearchResultRow
                                            key={index}
                                            id={elem.id}
                                            login={elem.login}
                                            result={result}
                                            setResult={setResult}
                                        />
                                    }
                                    )
                                }
                            </tbody>
                        </table>
                    </>
            }
        </section>
    </>
    );
}


export default AdminComponent;